import React, { Fragment } from "react";
import DataTable from "../../.././Datatable/DataTable";
import WithCard from "../../../../../common/withCard";

const PortfolioReturns = ({
  portfolio_return_table_heading,
  portfolio_return_table_data,
  benchmark_name,
  model_name,
  display_orig_portfolio,
}) => {
  return (
    <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
      <WithCard>
        <h4 className="text-uppercase bold" style={{ display: "inline" }}>
          Portfolio returns{" "}
        </h4>
        <Fragment>
          {portfolio_return_table_data.length > 0 &&
          portfolio_return_table_heading.length === 3 &&
          portfolio_return_table_data[0].length === 3 ? (
            <div>
              <DataTable
                data={portfolio_return_table_data}
                columns={portfolio_return_table_heading}
                paging={false}
                searching={false}
              />
              {benchmark_name ? (
                <div>
                  <b>*</b> <small>{benchmark_name}</small>
                </div>
              ) : null}
            </div>
          ) : null}
        </Fragment>

        <Fragment>
          {portfolio_return_table_heading.length === 4 &&
          portfolio_return_table_data.length > 0 &&
          portfolio_return_table_data[0].length ===
            portfolio_return_table_heading.length ? (
            <div>
              <DataTable
                data={portfolio_return_table_data}
                columns={portfolio_return_table_heading}
                paging={false}
                searching={false}
              />
              {benchmark_name && display_orig_portfolio ? (
                <div>
                  <b>*</b> <small>{benchmark_name}</small>
                </div>
              ) : null}
              {model_name ? (
                <div>
                  <small>
                    <b>+</b>&nbsp;{model_name}
                  </small>
                </div>
              ) : null}
            </div>
          ) : null}
        </Fragment>
      </WithCard>
    </div>
  );
};
export default PortfolioReturns;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/Returns/section1/portfolioReturns.jsx